import { $crud } from "./CrudFactory";

export async function twoFactorRequest(method, url, data = {}) {
  try {
    const options = { notify: false };
    if (method === "get") return await $crud.get(url, data, options);
    if (method === "put") return await $crud.put(url, data, options);
    return await $crud.post(url, data, options);
  } catch (err) {
    if (err && typeof err === "object") return err;
    return { status: false, message: (err && err.message) || "" };
  }
}

export function methodLabel(type, strings) {
  if (type === "sms") return strings.twofa_method_sms || "Text message";
  if (type === "email") return strings.twofa_method_email || "Email";
  if (type === "totp") return strings.twofa_method_totp || "Authenticator app";
  return type;
}
